import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { makeKeyed } from '../utils/utils';
import { categories, marketingCategories, salesCategories, serviceCategories, tools, marketingHubTools, salesHubTools, serviceHubTools } from 'academy-common-lib/constants/categories';
import { UserTrackStatuses } from './TracksConstants';
export const AWARD_TYPES = ['ONLY_SHOW_CERTIFICATE_COURSES'];
export const CATEGORIES = categories;
export const LESSON_TYPES = ['LESSON', 'TEMPLATE', 'EBOOK'];
export const CONTENT_TYPES = ['LEARNING_PATH', 'COURSE', 'LESSON', 'SHORT_FORM_CONTENT', 'TEMPLATE', 'EBOOK'];
export const DURATIONS = ['THIRTY_MINUTES_OR_LESS', 'THIRTY_MINUTES_TO_ONE_HOUR', 'ONE_TO_TWO_HOURS', 'TWO_TO_THREE_HOURS', 'MORE_THAN_THREE_HOURS'];
export const LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];
export const LEVELS = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'];
export const SORT_BYS = ['RECENTLY_ACCESSED', 'TITLE_ASC', 'TITLE_DESC'];
export const SORT_BY_MY_PLAYLISTS = ['RELEVANCE_DESCENDING', 'RELEVANCE_ASCENDING', 'RECENTLY_ACCESSED_DESCENDING', 'RECENTLY_ACCESSED_ASCENDING'];
export const SORT_BY_MY_PLAYLISTS_NO_SEARCH = ['RECENTLY_ACCESSED_DESCENDING', 'RECENTLY_ACCESSED_ASCENDING'];
export const SORT_BY_RELEVANCE = ['RELEVANCE_DESCENDING', 'RELEVANCE_ASCENDING'];
export const SORT_BY_ACCESS = ['RECENTLY_ACCESSED_DESCENDING', 'RECENTLY_ACCESSED_ASCENDING'];
export const PROGRESS_STATUS = [UserTrackStatuses.IN_PROGRESS, UserTrackStatuses.COMPLETED];
export const ASSIGNED_BY = ['EVERYONE', 'ME'];
export const STATUSES = ['IN_PROGRESS', 'COMPLETED', 'NOT_STARTED', 'EXPIRING_SOON'];
export const CREATED_BY = ['ME', 'ARCHIVED'];
export const TOOLS = tools;
export const FILTER_CONSTS = makeKeyed({
  AWARD_TYPES,
  CATEGORIES,
  CONTENT_TYPES,
  DURATIONS,
  LANGUAGES,
  LESSON_TYPES,
  LEVELS,
  SORT_BYS,
  STATUSES,
  TOOLS,
  CREATED_BY
});
const minute = 60;
const hour = minute * 60;
export const DURATION_BOUNDS = {
  THIRTY_MINUTES_OR_LESS: [0, minute * 30],
  THIRTY_MINUTES_TO_ONE_HOUR: [minute * 30, hour],
  ONE_TO_TWO_HOURS: [hour, hour * 2],
  TWO_TO_THREE_HOURS: [hour * 2, hour * 3],
  MORE_THAN_THREE_HOURS: [hour * 3, hour * 1000]
};
export const VISIBILITY_GROUPS = ['ALL_CONTENT', 'ACADEMY', 'CUSTOM_CONTENT'];
export const FILTER_TYPES = {
  CATEGORY: 'cat',
  SEARCH: 'search',
  SEARCH_USER: 'searchUser',
  SEARCH_TEAMS: 'searchTeams',
  SORT_BY: 'sortBy',
  ASSIGNED_BY: 'assignedBy',
  AWARD_TYPE: 'awardType',
  LEVEL: 'level',
  DURATION: 'duration',
  CONTENT_TYPE: 'contentType',
  CONTENT_SOURCE: 'contentSource',
  LANGUAGE: 'language',
  TOOLS: 'tools',
  CREATED_BY: 'createdBy',
  MY_PLAYLISTS_TYPE: 'myPlaylistsType',
  SORT_BY_MY_PLAYLISTS: 'sortByMyPlaylists',
  PROGRESS_STATUS: 'progressStatus',
  SORT_BY_RELEVANCE: 'sortBy',
  SORT_BY_ACCESS: 'sortBy'
};
export const FILTER_TYPES_OTHER = {
  CATEGORIES: 'cat',
  TOOLS: 'tools',
  SEARCH: 'search'
};
export const MarketingHubTools = ImmutableSet(marketingHubTools);
export const SalesHubTools = ImmutableSet(salesHubTools);
export const ServiceHubTools = ImmutableSet(serviceHubTools);
const MarketingCategoriesSet = ImmutableSet(marketingCategories);
const SalesCategoriesSet = ImmutableSet(salesCategories);
const ServiceCategoriesSet = ImmutableSet(serviceCategories);
export const getCategoryGroup = category => {
  return MarketingCategoriesSet.contains(category) || category === 'MARKETING' ? 'MARKETING' : SalesCategoriesSet.contains(category) || category === 'SALES' ? 'SALES' : ServiceCategoriesSet.contains(category) || category === 'SERVICE' ? 'SERVICE' : '';
};
export const getToolGroup = tool => {
  return MarketingHubTools.contains(tool) || tool === 'MARKETING_HUB_TOOLS' ? 'MARKETING_HUB_TOOLS' : SalesHubTools.contains(tool) || tool === 'SALES_HUB_TOOLS' ? 'SALES_HUB_TOOLS' : ServiceHubTools.contains(tool) || tool === 'SERVICE_HUB_TOOLS' ? 'SERVICE_HUB_TOOLS' : '';
};
const addAllOptionToCategories = (categorySet, allIndex) => {
  return categorySet.add(allIndex).sort((a, b) => a === allIndex ? -1 : b === allIndex ? 1 : a.localeCompare(b));
};
export const mapSoftwareFiltersWithAll = hsSoftwareFilters => ImmutableMap({
  MARKETING_HUB_TOOLS: addAllOptionToCategories(MarketingHubTools.intersect(hsSoftwareFilters), 'MARKETING_HUB_TOOLS'),
  SALES_HUB_TOOLS: addAllOptionToCategories(SalesHubTools.intersect(hsSoftwareFilters), 'SALES_HUB_TOOLS'),
  SERVICE_HUB_TOOLS: addAllOptionToCategories(ServiceHubTools.intersect(hsSoftwareFilters), 'SERVICE_HUB_TOOLS')
}).merge(hsSoftwareFilters.subtract(MarketingHubTools, SalesHubTools, ServiceHubTools).toMap());
export const mapWizardCategories = (subcategories, toolCategories) => {
  return ImmutableMap({
    MARKETING: addAllOptionToCategories(MarketingCategoriesSet.intersect(subcategories), 'MARKETING'),
    SALES: addAllOptionToCategories(SalesCategoriesSet.intersect(subcategories), 'SALES'),
    SERVICE_SUPPORT: addAllOptionToCategories(ServiceCategoriesSet.intersect(subcategories), 'SERVICE'),
    WEB_DESIGN_DEVELOPMENT: ImmutableSet(),
    ARTIFICIAL_INTELLIGENCE: ImmutableSet(),
    HUBSPOT_SOFTWARE: mapSoftwareFiltersWithAll(toolCategories)
  });
};
export const mapAcad021Categories = categoriesSet => ImmutableMap({
  MARKETING: addAllOptionToCategories(MarketingCategoriesSet.intersect(categoriesSet), 'MARKETING'),
  SALES: addAllOptionToCategories(SalesCategoriesSet.intersect(categoriesSet), 'SALES'),
  SERVICE: addAllOptionToCategories(ServiceCategoriesSet.intersect(categoriesSet), 'SERVICE')
}).merge(categoriesSet.subtract(MarketingCategoriesSet, SalesCategoriesSet, ServiceCategoriesSet).toMap());